/* ==========================================================================
   Klaviyo signup — footer form, popup and the /pages/signup form.
   Posts to Klaviyo's client subscriptions endpoint (public company id only, no
   secret key). The consent box must be ticked: CASL express consent.
   ========================================================================== */
(function () {
  var cfg = window.SABR_KLAVIYO;
  if (!cfg) return;

  // Shopify HTML-escapes translations ("you&#39;d"); turn them back into text.
  var decoder = document.createElement('textarea');
  Object.keys(cfg.strings).forEach(function (k) { decoder.innerHTML = cfg.strings[k]; cfg.strings[k] = decoder.value; });

  var STORE = 'sabr_ksign';           // localStorage: 'subscribed' or a close timestamp
  var SNOOZE_DAYS = 14;

  function read() { try { return localStorage.getItem(STORE); } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(STORE, v); } catch (e) {} }

  function subscribe(email, source) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + cfg.companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  locale: cfg.language + '-CA',   // feeds Klaviyo's "Locale: Language" (FR/EN segments)
                  properties: { 'Language': cfg.language, 'Signup source': source }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: cfg.listId } } }
        }
      })
    }).then(function (r) { if (!r.ok) throw new Error('subscribe ' + r.status); });
  }

  /* --- forms ---------------------------------------------------------------- */

  function bind(form) {
    var msg = form.querySelector('[data-ksign-msg]');
    var btn = form.querySelector('button[type="submit"]');
    function say(text, kind) { msg.textContent = text; msg.setAttribute('data-kind', kind || ''); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(cfg.strings.invalidEmail, 'error'); form.email.focus(); return; }
      if (!form.consent.checked) { say(cfg.strings.consentRequired, 'error'); form.consent.focus(); return; }

      btn.disabled = true;
      subscribe(email, form.getAttribute('data-source'))
        .then(function () {
          write('subscribed');
          if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email });
          form.classList.add('is-done');
          var custom = form.getAttribute('data-success');
          say(custom || cfg.strings.success, 'ok');
          var code = form.querySelector('[data-ksign-code]');
          if (code) code.hidden = false;
          // The popup's "No thanks" makes no sense once they've said yes.
          var no = form.closest('[data-kpop]') && form.closest('[data-kpop]').querySelector('.kpop__no');
          if (no) no.textContent = cfg.strings.close || no.textContent;
        })
        .catch(function () { btn.disabled = false; say(cfg.strings.error, 'error'); });
    });
  }

  document.querySelectorAll('[data-ksign]').forEach(bind);

  /* --- popup ---------------------------------------------------------------- */

  var pop = document.querySelector('[data-kpop]');
  if (!pop) return;

  var state = read();
  if (state === 'subscribed') return;
  if (state && Date.now() - Number(state) < SNOOZE_DAYS * 864e5) return;

  var opened = false, lastFocus = null;

  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    pop.hidden = false;
    document.documentElement.classList.add('kpop-open');
    var first = pop.querySelector('input[type="email"]');
    if (first) first.focus({ preventScroll: true });
  }
  function close() {
    pop.hidden = true;
    document.documentElement.classList.remove('kpop-open');
    if (read() !== 'subscribed') write(String(Date.now()));
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  pop.querySelectorAll('[data-kpop-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });

  setTimeout(open, 6000);
  // Desktop exit intent: pointer leaves through the top of the window.
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
  }
})();
